import { IAction as Action } from '../../models';
import ReducerCreator from '../registerReducer';
import { buildStoreItem } from '../storeItemBuilder';
import * as ACTIONS from './actions.constants';
import { StoreItem } from '../Store';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';

const r = new ReducerCreator<Action>()
    .register<void>(ACTIONS.ACTIONS_LOAD, (state) => {
        return (Object as any).assign({}, state, { isLoading: true, isLoaded: false, hasError: false, error: null });
    })
    .register<Action[]>(ACTIONS.ACTIONS_LOAD_SUCCESS, (state, payload) => {
        const newState = buildStoreItem(payload);
        return newState;
    })
    .register<any>(ACTIONS.ACTIONS_LOAD_ERROR, (state, payload) => {
        return (Object as any).assign({}, state, { isLoading: false, isLoaded: false, hasError: true, error: payload });
    })
    .register<void>(ACTIONS.ACTION_ADD, (state) => {
        return (Object as any).assign({}, state, { isLoading: true, isLoaded: false, hasError: false, error: null });
    })
    .register<Action>(ACTIONS.ACTION_ADD_SUCCESS, (state, payload) => {
        const newState: StoreItem<Action> = (Object as any).assign({}, state, { isLoading: false, isLoaded: true, hasError: false, error: null });
        newState.dictionary[payload.guid] = payload;
        return newState;
    })
    .register<any>(ACTIONS.ACTION_ADD_ERROR, (state, payload) => {
        return (Object as any).assign({}, state, { isLoading: false, isLoaded: false, hasError: true, error: payload });
    })
    .register<void>(ACTIONS.ACTION_UPDATE, (state) => {
        return (Object as any).assign({}, state, { isLoading: true, isLoaded: false, hasError: false, error: null });
    })
    .register<Action>(ACTIONS.ACTION_UPDATE_SUCCESS, (state, payload) => {
        const newState: StoreItem<Action> = (Object as any).assign({}, state, { isLoading: false, isLoaded: true, hasError: false, error: null });
        newState.dictionary[payload.guid] = payload;
        return newState;
    })
    .register<any>(ACTIONS.ACTION_UPDATE_ERROR, (state, payload) => {
        return (Object as any).assign({}, state, { isLoading: false, isLoaded: false, hasError: true, error: payload });
    })
    .register<void>(ACTIONS.ACTION_DELETE, (state) => {
        return (Object as any).assign({}, state, { isLoading: true, isLoaded: false, hasError: false, error: null });
    })
    .register<Action>(ACTIONS.ACTION_DELETE_SUCCESS, (state, payload) => {
        const newState: StoreItem<Action> = (Object as any).assign({}, state, { isLoading: false, isLoaded: true, hasError: false, error: null });
        const { dictionary } = newState;
        delete dictionary[payload.guid];
        return newState;
    })
    .register<any>(ACTIONS.ACTION_DELETE_ERROR, (state, payload) => {
        return (Object as any).assign({}, state, { isLoading: false, isLoaded: false, hasError: true, error: payload });
    })
    .register<any>(APPLICATION_DISCONNECTED, () => {
        return new StoreItem<Action>();
    });

export function actionsReducer(state: StoreItem<Action> = new StoreItem<Action>(), action: { type: string, payload: any }) {
    return r.reduce(state, action);
}
